/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Load_HistoryInputs */

const vi_vehicle_gps_load_history = /** @type {(inputs: Vehicle_Gps_Load_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải hành trình`)
};

/**

* @param {Vehicle_Gps_Load_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_load_history = /** @type {((inputs?: Vehicle_Gps_Load_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Load_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_load_history(inputs)
});